import { render, staticRenderFns } from "./Celula.vue?vue&type=template&id=6d11ec16&scoped=true"
import script from "./Celula.vue?vue&type=script&lang=js"
export * from "./Celula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d11ec16",
  null
  
)

export default component.exports